import React from "react";
import { FileDownloader, StaticDropdown } from "src/Components";
import type {
  IPortfoGroupBuyingPowerSummarySearchParams,
  IPortfoGroupBuyingPowerSummaryTableReport,
} from "src/Interfaces/portfolioGroups";
import {
  getPortfoGroupBuyingPowerSummaryExcel,
  getPortfoGroupBuyingPowerSummaryTable,
} from "src/Requests/portfolioGroups";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { portfolioGroupExchangeTypeOptions } from "src/Utils/exchangeTypeOptions";
import AllocationTableUI from "../StatusSummary/AllocationTableUI";
import PortfolioFilterMultiSelects from "../PortfolioFilterMultiSelects";

const BuyingPowerSummary = () => {
  const [searchParams, setSearchParams] =
    React.useState<IPortfoGroupBuyingPowerSummarySearchParams>({
      portfoGroupIds: [],
      accountIds: [],
      exchangeType: null,
    });

  const multiSelectFilterChangeHandler = (
    name: "portfoGroupIds" | "accountIds",
    value: string[],
  ) => {
    setSearchParams((prev) => ({ ...prev, [name]: value.map(Number) }));
  };

  const exchangeTypeChangeHandler = (_: string, value: number | string) => {
    setSearchParams((prev) => ({
      ...prev,
      exchangeType: value === "" || value == null ? null : Number(value),
    }));
  };

  return (
    <div className="flex flex-col flex-1 w-full gap-3">
      <div className="flex flex-row justify-start items-end gap-3">
        <PortfolioFilterMultiSelects
          portfoGroupIds={searchParams.portfoGroupIds ?? []}
          accountIds={searchParams.accountIds ?? []}
          onChange={multiSelectFilterChangeHandler}
        />
        <div className="w-[220px]">
          <StaticDropdown
            dropdown={{
              name: "exchangeType",
              placeholder: "بورس",
              extraLabel: true,
            }}
            options={portfolioGroupExchangeTypeOptions}
            onChange={exchangeTypeChangeHandler}
            value={searchParams.exchangeType?.toString() ?? ""}
          />
        </div>
        <div className="w-36">
          <FileDownloader getFile={() => getPortfoGroupBuyingPowerSummaryExcel(searchParams)} />
        </div>
      </div>
      <TableTemplate<
        IPortfoGroupBuyingPowerSummarySearchParams,
        IPortfoGroupBuyingPowerSummaryTableReport
      >
        getDataTable={getPortfoGroupBuyingPowerSummaryTable}
        searchParameters={searchParams}
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <AllocationTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            autoSizeAccountColumns
            sameSizeMultilineHeaders
            tableBoxClassName="max-h-[800px] portfolio-group-first-row"
          />
        )}
        refreshTableTime={30000}
        pagesize={200}
        withSort
        tableWrapperClassname="!mx-0"
      />
    </div>
  );
};

export default BuyingPowerSummary;
